import { isPlatform } from "@ionic/core";

/**
 * The platform service - tells which platform we're on.
 *
 * It's important to note that the localStorage section is used for unit tests - specifically cypress. We will set a local storage key
 * in those tests so that we can override which platform we're actually using.  This is not the way we do it in production - its
 * the target from the .env when we compile it for dist
 */

const PlatformService = {
  isMobile() {
    return window.localStorage.getItem("__TEST__PLATFORM__TARGET__")
      ? window.localStorage.getItem("__TEST__PLATFORM__TARGET__") === "mobile"
      : process.env.VUE_APP_PLATFORM_TARGET === "mobile";
  },

  isWeb() {
    return window.localStorage.getItem("__TEST__PLATFORM__TARGET__")
      ? window.localStorage.getItem("__TEST__PLATFORM__TARGET__") === "web"
      : process.env.VUE_APP_PLATFORM_TARGET === "web";
  },

  isAndroid() {
    return isPlatform("android");
  },

  isTest() {
    return process.env.NODE_ENV !== "production";
  }
};

export default PlatformService;
